module.exports = __webpack_public_path__ + "school/img/campus_health_video_play_border.919a60b9.jpg";